// extracted by mini-css-extract-plugin
export var poemAuthorTitle = "style-module--poemAuthorTitle--w9X-u";
export var poemContent = "style-module--poemContent--eLAqJ";
export var homepageAuthor = "style-module--homepageAuthor--lgWrU";
export var homepageAuthorImage = "style-module--homepageAuthorImage--+znDX";
export var alphabetList = "style-module--alphabetList--QdWJF";
export var youtubeLink = "style-module--youtubeLink--RBJCo";
export var aboutUsMain = "style-module--aboutUsMain--5kooX";
export var aboutUsLeft = "style-module--aboutUsLeft--4QHc5";
export var aboutUsRight = "style-module--aboutUsRight--YITJA";
export var paperMain = "style-module--paperMain--thMOy";
export var poemMain = "style-module--poemMain--MtDKY";
export var poemDiv = "style-module--poemDiv--WSmQM";
export var logoImage = "style-module--logoImage--kr8bJ";
export var logoImageWrapper = "style-module--logoImageWrapper--GPzIe";
export var topicMain = "style-module--topicMain--vSomD";
export var indexVideoPlayer = "style-module--indexVideoPlayer--Jhheq";
export var indexMain = "style-module--indexMain--n5ofG";
export var indexRight = "style-module--indexRight--WLcDb";
export var indexLeft = "style-module--indexLeft--h7x0x";
export var backToTop = "style-module--backToTop--4BVxi";